const COMMA = ',';
const COMMA_AND_SPACE = ",e";
const DEFAULT_FIRST_LETTER = "e";
const PERIOD = '.';
const SPACE = " ";
const RULE_OPERATOR = ":-";
const UNDERSCORE = "_";
const DOUBLE_SPACE = "  ";

export default {

  getDefaultTranslation(naturalLanguageExpression) {
    let nl = naturalLanguageExpression
      .trim()
      .replace(RULE_OPERATOR, COMMA_AND_SPACE)
      .replace(DOUBLE_SPACE, SPACE);
    let result = "";
    for (let i = 0; i < nl.length; i++) {
      const c = nl[i];
      if (c === PERIOD) {
        // skip
        continue;
      }
      if (/\s/.test(c)) {
        result += UNDERSCORE;
      } else if (c === COMMA || /[a-zA-Z0-9]/.test(c)) {
        result += c;
      } else {
        result += c.charCodeAt(0);
      }
    }
    if (/\d/.test(result.charAt(0))) {
      result = DEFAULT_FIRST_LETTER + result;
    }
    return result.toLowerCase();
  }

}